<template>
    <div  v-if="isNipEmployee" class="mb-3" :class="sizeClassObject">
        <div class="card border-secondary h-100">
            <div class="card-header pb-0">
                <div class="btn-toolbar justify-content-between" role="toolbar">
                    <div>
                        <h5>
                            <i class="fas fa-university"></i>
                            {{ $t('learningActivity') }}
                        </h5>
                    </div>
                    <div>
                        <h5>
                            <button v-if="expanded" class="btn btn-link" @click.stop="sizeToggle">
                                <i class="fas fa-compress-arrows-alt"></i>
                            </button>
                            <button v-else class="btn btn-link" @click.stop="sizeToggle">
                                <i class="fas fa-expand-arrows-alt"></i>
                            </button>
                        </h5>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-md-4 col-sm-12">
                        <kendo-dropdownlist v-model="yearFilterlistValue"
                                            :data-source="yearFilterSourceArray"
                                            :data-text-field="'text'"
                                            :data-value-field="'value'"
                                            :filter="'contains'"
                                            style="width:100%"></kendo-dropdownlist>
                    </div>
                </div>
                <div class="card-deck">
                    <event-statuses :getValid="true" :yearFilterValue="yearFilterlistValue"></event-statuses>
                    <valid-participants :getValid="true" :yearFilterValue="yearFilterlistValue"></valid-participants>
                    <valid-lecturers :getValid="true" :yearFilterValue="yearFilterlistValue"></valid-lecturers>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import EventStatuses from '@/components/dynamic/statuses/EventsStatuses_new';
    import ValidParticipants from '@/components/dynamic/statuses/ValidParticipants';
    import ValidLecturers from '@/components/dynamic/statuses/ValidLecturers';
    import { DynamicLayoutPageSize } from '@/models/enums';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                expanded: this.size === 12,
                yearFilterlistValue: 0,
                yearFilterSourceArray: [
                    { text: this.$t('yearRangeSelector.curentYear'), value: 0 },
                    { text: this.$t('yearRangeSelector.previousYear'), value: 1 },
                    { text: this.$t('yearRangeSelector.all'), value: 999 }
                ]
            }
        },
        components: {
            EventStatuses,
            ValidParticipants,
            ValidLecturers
        },
        computed: {
            ...mapGetters(['claims']),
            isNipEmployee() {
                //return this.$store.getters.userRoles.includes(Role.Nip);
                return this.$store.getters.claims.nijEmployee.read;
            },
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.expanded ? DynamicLayoutPageSize.Max : Math.min(this.size, 6));
            }
        },
        methods: {
            sizeToggle() {
                this.expanded = !this.expanded;
            },
        }
    }
</script>
